import { BrowserRouter } from 'react-router-dom'
import { MainRouter } from './app/router'
import { VersionBadge } from './components/VersionBadge'
import { ChromeExtensionCaptcha, PrivyProvider } from '@privy-io/react-auth'
import { useApp } from './store'
import { useEffect, useState } from 'react'
import { SuccessNotification } from './shared'
import { PRIMARY_COLORS, PRIMARY_COLORS_DARK } from './utils/colors'

const PRIVY_APP_ID = import.meta.env.VITE_PRIVY_APP_ID
if (!PRIVY_APP_ID) {
  throw new Error('VITE_PRIVY_APP_ID is not set')
}

export function App() {
  const mode = useApp((state) => state.mode)
  const [showResendNotification, setShowResendNotification] = useState(false)

  useEffect(() => {
    // Intercept clicks on Privy's resend button
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      
      // Check if clicked element or its parent contains "resend" text
      const isResendButton =
        target.textContent?.toLowerCase().includes('resend') ||
        target.closest('button')?.textContent?.toLowerCase().includes('resend')

      if (isResendButton) {
        // Show notification when resend is clicked
        setShowResendNotification(true)
      }
    }

    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click', handleClick, true)
    }
  }, [])

  return (
    <>
    <PrivyProvider
      appId={PRIVY_APP_ID}
      captchaComponent={ChromeExtensionCaptcha}
      config={{
        appearance: {
          theme: mode,
          accentColor: mode === 'light' ? PRIMARY_COLORS[500] : PRIMARY_COLORS_DARK[500],
            logo: mode === 'light' ? '/login-logo-light.png' : '/login-logo-dark.png',
        },
        // Create embedded wallets for users who don't have a wallet
        // embeddedWallets: {
        // createOnLogin: 'users-without-wallets',
        // },
        supportedChains: [
          {
            id: 101,
            name: 'Solana',
            nativeCurrency: {
              name: 'Solana',
              symbol: 'SOL',
              decimals: 9,
            },
            rpcUrls: {
              default: {
                http: ['https://api.devnet.solana.com'],
                webSocket: ['wss://api.devnet.solana.com'],
              },
            },
          },
        ],
      }}
    >
      <main className='dawn bg-neutral-50 dark:bg-neutral-1000 text-neutral-900 dark:text-neutral-50 min-h-screen transition-colors'>
        <BrowserRouter>
          <MainRouter />
        </BrowserRouter>
        <VersionBadge />
      </main>
    </PrivyProvider>
      {showResendNotification && (
        <SuccessNotification
          message='Code resent! Please check your inbox now.'
          onClose={() => setShowResendNotification(false)}
        />
      )}
    </>
  )
}
